import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {loadUsers, saveUser, unlockUser, deleteUser} from '../../actions/userActions';
import {loadRoles} from '../../actions/roleActions';
import { Button, Collapse, Label, Input, FormGroup} from 'reactstrap';
import {find, some, remove, join} from 'lodash';
import Select from 'react-select';
import {toastr} from 'react-redux-toastr';
import moment from 'moment';
import {EMPTY_GUID, URL_NewClientLocation, validationCreator} from '../../constants';
import UserAuthenticationRequestsControl from '../Users/UserAuthenticationRequestsControl';
import { Link } from 'react-router-dom';
import { push } from '../../utils/navigation';

class UserRequestToJoinPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {};
  }

  render() {
    return (<div>
      <div className="row">
        <div className="col-6 col-md-12 col-lg-12">
          <h2>Welcome to SRS</h2>
          <p>You're nearly there, please complete you're profile and either request access to a Client or Location</p>
          <p>Once you have a complete user profile you may create a request for access using an existing Client Id or Location Id,
            otherwise you'll be able to create a new Client</p>
        </div>
      </div>

      { this.props.account && this.props.account.user &&
      <UserAuthenticationRequestsControl
        account={this.props.account}
        userId={this.props.account.user.id}
        requestsUpdated={() => {}}
        onCreateNewClient={() => this.props.dispatch(push(URL_NewClientLocation))}
        showUserPhoneWarning={true}
      />}

    </div>);
  }
}

UserRequestToJoinPage.propTypes = {
  account: PropTypes.object.isRequired,
};

function mapStateToProps(state){
  return {
    account: state.account,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserRequestToJoinPage);
